<p-toast></p-toast>
<!-- Your Search Form -->
<div class="w-full" *ngIf="selectedSearchOption === 0">
  <form [formGroup]="filterForm_normal" (ngSubmit)="search()">
    <div class="w-full flex py-2 justify-betweeng gap-2 lg:gap-1 flex-wrap">
      <!-- Search Type Dropdown -->
      <div class="lg:w-[49.5%] w-full bg-[#F8FAFF] border py-2 px-2 border-gray-300 rounded-md">
        <h1 class="text-[#388e3c] text-xs my-1">Text Search Field</h1>
        <p-dropdown [options]="dropdownItems" optionLabel="truncatedLabel" optionValue="field"
          formControlName="search_type_simple" placeholder="Select Field" filter="true"
          [filterBy]="'truncatedLabel'" [(ngModel)]="selectedSearchType"
          (onChange)="onDropdownChange($event)">
        </p-dropdown>
      </div>

      <!-- Autocomplete Search Field -->
      <div class="relative lg:w-[49.5%] w-full bg-[#F8FAFF] border py-2 px-2 border-gray-300 rounded-md">
        <!-- Input Label -->
        <h1 class="text-[#388e3c] text-xs my-1">Enter Your Keyword</h1>

        <!-- Input Field -->
        <input type="text" placeholder="Enter Your Keyword (e.g., CHLORANTRANILIPROLE OR RYNAXYPYR (DPX-E2Y45))"
          (input)="searchKeyword($event)" formControlName="textautocomplete"
          class="w-full bg-transparent text-sm text-gray-500 font-semibold focus:outline-none placeholder:text-gray-400 placeholder:italic" />

        <!-- Suggestion Box -->
        <div
          class="search_top_body_container_simple_mid_right_suggestion bg_2 p-y-8 p-x-16 border-radius-6 mt-2 absolute w-full z-10"
          *ngIf="isShowAutoSearch && results_suggestion.length">
          <ng-container *ngFor="let item of results_suggestion; let i = index">
            <div
              class="search_top_body_container_simple_mid_right_suggestion_item p-y-8 color_black font_14 weight_500 cursor_pointer"
              (click)="autoSearchSelect(item)">
              <div class="search_item_content">
                <img src="../../../assets/icons/search_icon.png" class="search_icon" />
                <div class="search_text">{{ item.search_value }}</div>
                <div class="column_name pt-1 pb-1">
                  <span class="bg-warning text-dark rounded pt-1 pb-1 px-2 small-font">{{ item.columnname }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap items-center gap-2 text-green-800 text-md">
      <!-- First Item -->
      <div class="bg-[#ffcd04] px-4 py-2 font-14 font-bold rounded-lg text-left flex items-center cursor-pointer"
        (click)="
          staticSuggestion(
            'active ingredient',
            'activeIngredient',
            'CHLORANTRANILIPROLE OR RYNAXYPYR'
          )
        ">
        <div class="text-[#303027] font-medium text-[14px] leading-[18px]">
          <div>Active Ingredient:</div>
          <div>CHLORANTRANILIPROLE OR RYNAXYPYR (DPX-E2Y45)</div>
        </div>

        <div class="pl-4">
          <img src="../../../assets/icons/black_arrow.png" alt="Arrow" class="mt-3 md:mt-0" />
        </div>
      </div>
      <div class="bg-[#ffcd04] px-4 py-2 font-14 font-bold rounded-lg text-left flex items-center cursor-pointer"
        (click)="downloadPDF()">
        <div class="text-[#303027] font-medium text-[14px] leading-[18px]">
          <div>User</div>
          <div>Guide</div>
        </div>

        <div class="pl-4">
          <img src="../../../assets/icons/download.png" alt="Arrow" class="mt-3 md:mt-0" />
        </div>
      </div>

      <!-- Buttons aligned to the right without wrapping -->
      <div class="mt-3 flex justify-end gap-4 w-full lg:w-[30%] md:w-[45%] ml-auto">
        <button type="submit"
          class="flex-grow px-4 py-3 text-[15px] leading-[18.29px] font-semibold rounded-full transition-all duration-300"
          style="
            background: linear-gradient(145.5deg, #388e3c, #0f4363 99.58%);
            color: rgb(255, 237, 141);
          "
          onmouseover="this.style.background='linear-gradient(145.5deg, #388e3c, #388e3c 99.58%)'; this.style.color='white';"
          onmouseout="this.style.background='linear-gradient(145.5deg, #388e3c, #0f4363 99.58%)'; this.style.color='rgb(255, 237, 141)';">
          Search
        </button>

        <button type="button"
          class="flex-grow border-2 px-4 py-3 text-[15px] leading-[18.29px] border-[#388e3c] font-semibold text-[#388e3c] rounded-full"
          (click)="resetallform()">
          Reset
        </button>
      </div>
    </div>

    <!-- <div class="flex flex-wrap-reverse justify-between gap-4 py-4 mt-2">
      <button
      type="button"
      class="mt-3 py-3 text-center px-4 bg-[#FFCD04] rounded-full w-full md:w-[36%] lg:w-[24%] font-semibold text-[#303030] text-[15px] leading-[18px] flex items-center justify-center gap-2"
      (click)="showVideoModal()"
    >
      Explore More With Tutorials
      <img
        src="../../../assets/icons/Video.png"
        alt="YouTube"
        class="w-5 h-5"
      />
    </button>
    
    <p-dialog
      header="Tutorial Video"
      [(visible)]="displayVideoModal"
      [modal]="true"
      [responsive]="true"
      [style]="{ width: '80vw' }"
    >
      <iframe
        *ngIf="videoUrl"
        [src]="videoUrl"
        width="100%"
        height="400"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </p-dialog>
    
      
    </div> -->
  </form>
</div>
<!-- Alert Dialogs if user not have privilege -->
<!-- Search Privilege dialog -->
<p-dialog header="Search Privilege" [(visible)]="is_show_Search_Priv_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't have permission to Search, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Search Exceed dialog -->
<p-dialog header="Daily Search Exceed" [(visible)]="is_show_Daily_Search_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily search limit, please contact the support team
      at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Search Exceed  dialog -->
<p-dialog header="Total Search Exceed" [(visible)]="is_show_Total_Search_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your search count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!-- Download  Privilege dialog -->
<p-dialog header="Download Privilege" [(visible)]="is_show_Download_Priv_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You don't permission to download, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Daily Download Exceed dialog -->
<p-dialog header="Daily Download Exceed" [(visible)]="is_show_Daily_Download_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      You have exceeded the daily download limit, please contact the support
      team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>

<!--  Total Downalod Exceed  dialog -->
<p-dialog header="Total Download Exceed " [(visible)]="is_show_Total_Download_Exceed_popup" [modal]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" [style]="{ width: '25vw', padding: '0px' }" [draggable]="false"
  [resizable]="false">
  <div class="privilege_container">
    <div class="privilege_container_icon">
      <img src="../../../assets/icons/exclamation-mark.png" alt="alert" />
    </div>
    <div class="privilege_container_text">
      Your download count is exhausted, please contact the support team at
      <a href="mailto:support@chemrobotics.com">support&#64;chemrobotics.com</a>
    </div>
    <div class="row privilege_container_buttons">
      <div class="col-12">
        <a href="mailto:support@chemrobotics.com">
          <button class="privilege_container_buttons_contact">
            Contact to ChemRobotics®
          </button>
        </a>
      </div>
    </div>
  </div>
</p-dialog>